<template>
  <o-dialog
    ref="dialog"
    :title="$t('components.customer.actions.creditCardRemove.title')"
    :info="info"
    :options="[
      { text: $t('general.cancel'), type: 'cancel' },
      { text: $t('general.confirm'), type: 'confirm', callback: confirm },
    ]"
    :portal="portal"
  />
</template>

<script setup lang="ts">
import type { Customer } from '~/_api/models/customer'

interface Props {
  customer: Customer
  creditCard: any
  portal?: string
  loading?: boolean
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

const props = withDefaults(defineProps<Props>(), {
  portal: undefined,
  loading: false,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()

const info = computed(() => {
  return $i18n.t('components.customer.actions.creditCardRemove.info', { cardLast4: props.creditCard.cardLast4 })
})

const open = () => {
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    const response = await $api.customer.deleteCreditCard(props.creditCard.idCustomerCreditCard?.toString() ?? props.creditCard.objectID?.())

    if (response.success) {
      $notification.toast({
        title: $i18n.t('components.customer.actions.creditCardRemove.success'),
        text: $i18n.t('components.customer.actions.creditCardRemove.successInfo', { cardLast4: props.creditCard.cardLast4 }),
      })

      emit('success')

      return response
    }

    $notification.toast({
      title: $i18n.t('components.customer.actions.creditCardRemove.error'),
      text: $i18n.t('components.customer.actions.creditCardRemove.errorInfo', { cardLast4: props.creditCard.cardLast4 }),
    })

    emit('error')
  } catch {
    $notification.toast({
      title: $i18n.t('components.customer.actions.creditCardRemove.error'),
      text: $i18n.t('components.customer.actions.creditCardRemove.errorInfo', { cardLast4: props.creditCard.cardLast4 }),
    })

    emit('error')
  } finally {
    emit('update:loading', false)
  }
}

defineExpose({ open })
</script>
